export default "__VITE_ASSET__rIR1KWlR__"